import { render, staticRenderFns } from "./consultationMultidisciplinary.vue?vue&type=template&id=341441a8&scoped=true&"
import script from "./consultationMultidisciplinary.vue?vue&type=script&lang=js&"
export * from "./consultationMultidisciplinary.vue?vue&type=script&lang=js&"
import style0 from "./consultationMultidisciplinary.vue?vue&type=style&index=0&id=341441a8&lang=scss&scoped=true&"
import style1 from "./consultationMultidisciplinary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341441a8",
  null
  
)

export default component.exports